PAYMENT_ERROR_GIFT_PAYMENT_PENDING